import React, { FunctionComponent } from 'react';
import cx from 'classnames';
import copy from 'clipboard-copy';
import { getGoogleMapsUrlByAddress } from '../../../../utils/googleMaps';
import { cep } from '../../../../utils/mask';
import { Icon } from '../../../Icons';
import styles from '../style.module.css';
import { AddressProps } from '../types';

interface Props {
  address: AddressProps;
}

interface ActionProps {
  onClick?: () => void;
  href?: string;
  icon: string;
  customClass?: string;
}

const Action: FunctionComponent<ActionProps> = ({ icon, children, onClick, href, customClass }) => {
  const actionClass = 'ml4 f14 fw6 abbey underline transition-ease ttn pointer';
  const className = cx('flex items-center f11 fw7 ttu', customClass, styles.actionClass);
  return (
    <a
      className={className}
      href={href}
      target="_blank"
      onClick={onClick}
      title={children as string} rel="noreferrer"
    >
      <Icon name={icon} className="mb4 boulder" width={16} height={16} customId={icon} />
      <span className={actionClass}>{children}</span>
    </a>
  );
};

export const AddressActions = ({ address }: Props) => {
  const { city, cepAddress, district, street } = address;
  const fullAddress = `${street} - ${district}, ${city}, ${cep(cepAddress)}`;
  const onClick = () => copy(fullAddress);

  const href = getGoogleMapsUrlByAddress(fullAddress);
  return (
    <div className="flex mv12">
      <Action icon="SvgIconCopy" onClick={onClick} customClass="mr8">
        Copiar
      </Action>
      <Action icon="SvgIconLocation" href={href}>
        Ir para mapa
      </Action>
    </div>
  );
};
